import { Box, CssBaseline, GlobalStyles } from "@mui/material";
import React from "react";

import VideoEditorWrapper from "./components/VideoEditorWrapper";
import AppContextProvider from "./context/AppContext";
import ErrorBoundary from "./components/ErrorBoundary";

// Just importing useKernel now
import { useKernel } from "./hooks/AIKernel"; 

const ThemedAppContent: React.FC = () => {
  const { agentState } = useKernel();
  
  const isDarkMode = agentState?.theme === "theme-cinematic-dark";

  return (
    <>
      <GlobalStyles
        styles={{
          "html, body": {
            minHeight: "100%",
            backgroundColor: isDarkMode ? "#0a0a0a" : "#ebebeb",
            color: isDarkMode ? "#ffffff" : "#000000",
            transition: "background-color 0.5s ease, color 0.5s ease",
            padding: "0 !important",
            margin: 0,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: isDarkMode ? "#121212" : "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: isDarkMode ? "#333333" : "#c1c1c1",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: isDarkMode ? "#00e5ff" : "#a8a8a8",
            },
          },
        }}
      />
      <Box sx={{ width: "100%", height: "100dvh" }}>
        <ErrorBoundary>
          <AppContextProvider>
            <VideoEditorWrapper />
          </AppContextProvider>
        </ErrorBoundary>
      </Box>
    </>
  );
};

function App() {
  return (
    // Wrapped in a React Fragment to satisfy the single-parent rule
    <>
      <CssBaseline />
      <ThemedAppContent />
    </>
  );
}

export default App;